import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Portal,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { BiChevronDown } from 'react-icons/bi';
import { MdLanguage } from 'react-icons/md';

interface Langs {
  [key: string]: {
    nativeName: string;
  };
}

const langs: Langs = {
  en: { nativeName: 'English' },
  ur: { nativeName: 'اردو' },
};

const LanguageSelect = () => {
  const { i18n } = useTranslation();
  return (
    <Menu>
      <MenuButton
        as={Button}
        size={'sm'}
        ml={1}
        mr={1}
        borderRadius={20}
        leftIcon={<MdLanguage />}
        rightIcon={<BiChevronDown />}
      >
        {langs[i18n.resolvedLanguage ?? 'en'].nativeName}
      </MenuButton>
      <Portal>
        <MenuList zIndex={1000}>
          {Object.keys(langs).map((lang) => (
            <MenuItem
              key={lang}
              value={lang}
              isDisabled={i18n.resolvedLanguage === lang}
              onClick={() => i18n.changeLanguage(lang)}
            >
              {langs[lang].nativeName}
            </MenuItem>
          ))}
        </MenuList>
      </Portal>
    </Menu>
  );
};

export default LanguageSelect;
